export var SET_OVERLAY_DATA = 'SET_OVERLAY_DATA';
export var setOverlayData = function (a) { return function (dispatch) { return dispatch({
    type: SET_OVERLAY_DATA,
    payload: a
}); }; };
//# sourceMappingURL=overlayAction.js.mapexport var SET_OVERLAY_DATA = 'SET_OVERLAY_DATA';
export var setOverlayData = function (a) { return function (dispatch) { return dispatch({
    type: SET_OVERLAY_DATA,
    payload: a
}); }; };
//# sourceMappingURL=overlayAction.js.map